export default __webpack_public_path__ + "static/Slide7-038f7230c03a8520102d2025f814898c.png";